import { render, staticRenderFns } from "./AddCardByDBDialog.vue?vue&type=template&id=d275c654"
import script from "./AddCardByDBDialog.vue?vue&type=script&lang=js"
export * from "./AddCardByDBDialog.vue?vue&type=script&lang=js"
import style0 from "./AddCardByDBDialog.vue?vue&type=style&index=0&id=d275c654&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports